import {
  ProductDetails,
  type ProductDetailsProps,
} from '@hyphengroup/cms-components/components/ProductDetails/ProductDetails';
import { ProductDetailsWrapperPersonalLoan } from './ProductDetailsWrapperPersonalLoan';
import { rendersTiProviderDetails } from './rendersTiProviderDetails';
import { usePageDataContextOptional } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { isRenderedFlexibleHero } from '$/components/cms/components-user/FlexibleHeroBlock/pdpFlushHeroSkip';
import { getHeroCtaLinkOverrideFor } from '$/components/cms/components-user/FlexibleHeroBlock/utils';
import { TiProductDetailsWrapper } from '$/components/cms/components-user/travel/TiProductDetails/TiProductDetailsWrapper';
import { usePdpModalConfigProps } from '$/components/cms/helpers/useProductDetailModal';

/**
 * BlockMapper dispatch wrapper for the ProductDetails component — keeps
 * BlockMapper branch-free (its case just renders this). Renders the tier-aware
 * TI provider-page wrapper when `renderingMode === 'TI_PROVIDER'`, the PL
 * wrapper (loan selection) on PL pages, otherwise the plain cms-components
 * ProductDetails (every other value, incl. absent → CC).
 */
export const ProductDetailsBlock = (
  props: ProductDetailsProps,
): JSX.Element | null => {
  // Only MODAL mode consumes these; harmless to page/TI modes (CMS-1924).
  const pdpModalConfigProps = usePdpModalConfigProps();
  const pageComponents = usePageDataContextOptional()?.pageData.page.components;
  if (rendersTiProviderDetails(props)) {
    return <TiProductDetailsWrapper {...props} />;
  }
  // On the full page the sticky footer goes where the page hero's CTA goes when the hero shows
  // this product (CMS-2043); a MODAL block's modal follows its PDP page's hero instead, through the
  // config it fetches.
  const ctaLinkOverride =
    props.renderingMode === 'MODAL'
      ? undefined
      : getHeroCtaLinkOverrideFor(
          pageComponents?.find(isRenderedFlexibleHero),
          props.product,
        );
  if (props.vertical === 'PERSONAL_LOANS') {
    return (
      <ProductDetailsWrapperPersonalLoan
        {...props}
        {...pdpModalConfigProps}
        ctaLinkOverride={ctaLinkOverride}
      />
    );
  }
  return (
    <ProductDetails
      {...props}
      {...pdpModalConfigProps}
      ctaLinkOverride={ctaLinkOverride}
    />
  );
};
